(function ($) {
  "use strict";

  jQuery(document).on('ready', function () {
    
    if (navigator.userAgent.indexOf('Mac OS X') != -1) {
       $("body").addClass("mac");
    }
    $(window).scroll(function() {
      if ($(window).scrollTop() > 300) {
        $('.scroll-arrow-top').addClass('home-scroll');
      } else {
        $('.scroll-arrow-top').removeClass('home-scroll');
      }
    }); 
    $('.product-mobi-images').each(function(){
      $(this).slick({
        slidesToShow:1,
        dots: true 
      });
    });
    
    $('.collection-slider').each(function(){
      var num_slides = 1;
      if(window.innerWidth >= 750)
      {
        var num_slides = $(this).data('slides');
      }
      $(this).slick({
        slidesToShow:num_slides,
        dots: true 
      })
    });
    $('.js-featuerd-review').each(function(){
      if(window.innerWidth >= 1023)
      {
        $(this).slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 2000,
        });
      }
      $(this).slick({
        slidesToShow: 1,
        dots:true,
        infinite: true,
        cssEase: 'linear',
      });
    });
    
    $('.items_content').click(function(e){
      e.preventDefault();
      var target = $($(this).attr('href'));
      if(target.length){
        var scrollTo = target.offset().top ;
        $('body, html').animate({scrollTop: scrollTo-150}, 3000);
      }
    });
   
    
    $('.section__header.right .icon-box').click(function(){
      $('.section__header.right .section-overplay').css('display', 'none');
      var src = $('.section__header.right').find('iframe').attr('src');
      $('.section__header.right').find('iframe').attr('src', src + '?autoplay=1&mute=1&rel=0&showinfo=0&vq=720');
    });

    
    
  });
})(jQuery);


